function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { BrowserSupportService } from '../utils/browser-support.service';
import { VueComponent } from '@progress/kendo-vue-common';
import Component from 'vue-class-component';
/**
 * @hidden
 */

var Header =
/** @class */
function (_super) {
  __extends(Header, _super);

  function Header() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.divStyle = {};
    _this.element = null;
    _this.headerWrap = null;
    _this.table = null;
    return _this;
  }

  Header.prototype.mounted = function () {
    // @ts-ignore
    this.element = this.$refs.header; // @ts-ignore

    this.headerWrap = this.$refs.headerWrap; // @ts-ignore

    this.table = this.$refs.table; // @ts-ignore

    this.$props.columnResize.colGroupHeader = this.$refs.colGroupHeader;
    var scrollbarWidth = new BrowserSupportService().scrollbarWidth;
    var rtl = this.element && getComputedStyle(this.element).direction === 'rtl' || false;
    var padding = Math.max(0, scrollbarWidth - 1) + 'px';
    var right = rtl ? 0 : padding;
    var left = rtl ? padding : 0;
    this.divStyle = {
      padding: "0 " + right + " 0 " + left
    };
  };
  /**
   *
   * @param scrollLeft - The scroll span to the left (in pixels).
   */


  Header.prototype.setScrollLeft = function (scrollLeft) {
    if (this.headerWrap) {
      this.headerWrap.scrollLeft = scrollLeft;
    }
  };
  /**
   *
   * @param width - The scroll width (in pixels).
   */


  Header.prototype.setWidth = function (width) {
    if (this.table) {
      this.table.style.width = width + 'px';
    }
  }; // @ts-ignore


  Header.prototype.render = function (h) {
    if (!this.$props.staticHeaders) {
      return this.$props.headerRow;
    }

    return h("div", {
      ref: 'header',
      "class": "k-grid-header",
      style: this.divStyle
    }, [h("div", {
      ref: 'headerWrap',
      "class": "k-grid-header-wrap"
    }, [h("table", {
      ref: 'table'
    }, [h("colgroup", {
      ref: 'colGroupHeader'
    }, [this.$props.cols]), this.$props.headerRow])])]);
  };

  Header = __decorate([Component({
    props: {
      staticHeaders: Boolean,
      headerRow: Object,
      columnResize: Object,
      cols: Array
    }
  })], Header);
  return Header;
}(VueComponent);

export { Header };